import React, { Component } from "react";
import { graphql } from "gatsby";
import { Helmet } from "react-helmet";
import { StaticQuery } from "gatsby";

export default class NewsletterSubscription extends Component {
  constructor(props) {
    super(props);
    this.newsletterType = props.newsletterType;
  }

  componentDidMount() {
    const formCreate = (options) => {
      if (!window.hbspt) {
        setTimeout(() => {
          formCreate(options);
        }, 100);
      } else {
        window.hbspt.forms.create({ ...options });
      }
    };

    formCreate({
      region: "na1",
      portalId: "7001828",
      formId: "ed258e38-579b-4a19-afc9-fe269b0dbe14",
      cssClass: "newsletter-subscription",
      target: ".newsletter-hubspot-form",
    });
  }

  render() {
    return (
      <StaticQuery
        query={graphql`
          {
            allDatoCmsNewsletterSubscription {
              edges {
                node {
                  id
                  subheading
                  heading
                  locale
                  newsletterType
                }
              }
            }
          }
        `}
        render={(data) => {
          const newsletterData =
            data.allDatoCmsNewsletterSubscription.edges.find((edge) => {
              return (
                edge.node.newsletterType?.toLowerCase() ===
                this.newsletterType?.toLowerCase()
              );
            });
          const { heading, subheading } = newsletterData.node;
          return (
            <section className="hds-container bg-thermaBlue text-white">
              <div className="hds-section max-w-3xl m-auto text-center">
                <h4 className="text-center text-xl uppercase font-heading">
                  {heading}
                </h4>
                <p>{subheading}</p>
                <div className="newsletter-hubspot-form"></div>
              </div>
            </section>
          );
        }}
      />
    );
  }
}
